export default __webpack_public_path__ + "static/media/elec-1.dc12fe0e.png";